import { MaterializeDto } from "app/V2ApiClient";
import { LoadingState } from "types";

export interface MaterializedPipelineState {
  materializedPipelineLoading: LoadingState;
  materializedPipelineHistory: MaterializeDto | null;
}

export const initialMaterializedPipeline: MaterializedPipelineState = {
  materializedPipelineLoading: LoadingState.idle,
  materializedPipelineHistory: null,
};
